import {put} from "redux-saga/effects";
import {
    createAppNotificationMessageActionCreator,
    IAppNotificationMessageActionCreator,
} from "../action/app_notification_message_action";

import {AppError, ErrorType} from "../../domain/model/app_error";
import {AddAppNotificationRequest} from "../request/app_notification_message_request";
import {AppNotificationType} from "../../domain/model/app_notification_message";

const actionCreatorForNotification: IAppNotificationMessageActionCreator = createAppNotificationMessageActionCreator();

const WarnList: ErrorType[] = [
    ErrorType.API_REQUEST_401,
    ErrorType.API_REQUEST_403,
    ErrorType.FIREBASE_AUTH_ERROR,
    ErrorType.TOKEN_ERROR,
    ErrorType.CLIENT_FETCH_ERROR,
    ErrorType.FAIL_PROJECT_CREATE,
    ErrorType.FAIL_PROJECT_OPEN,
    ErrorType.FAIL_CUSTOMER_SCOUT,
    ErrorType.FAIL_CLIENT_MEMBER_CREATE,
    ErrorType.FAIL_APPLY_CLIENT_EMAIL_ALREADY_USED,
];

const NotificationWhiteList: ErrorType[] = [
    ErrorType.TOKEN_ERROR,
    ErrorType.FAIL_APPLY_CLIENT_EMAIL_ALREADY_USED,
];

export function* handleErrorForHandler(error: AppError | any) {

    const error_type: ErrorType = error.type ? error.type : ErrorType.UNKNOWN;
    const isWarn: boolean = (WarnList.includes(error_type));

    // Notification通知
    if (!NotificationWhiteList.includes(error_type)) {
        const req: AddAppNotificationRequest = new AddAppNotificationRequest();
        req.type = isWarn ? AppNotificationType.WARN : AppNotificationType.ERROR;
        req.message = error.message || error.toString();
        yield put(actionCreatorForNotification.requestAddAction(req));
    }

}



// WEBPACK FOOTER //
// ./src/presentation/handler/handleErrorForHandler.ts